(() => {
 if (customElements.get('pryme-community')) return;
 customElements.define('pryme-community', class extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   this.ready = true;

   const filters = this.querySelector('.pryme-community__filters');
   const reviewItems = [...this.querySelectorAll('.pryme-community__review[data-community-item]')];
   const emptyState = this.querySelector('[data-empty]');
   const filterStatus = this.querySelector('[data-filter-status]');

   filters.hidden = false;
   filters.addEventListener('click', event => {
    const button = event.target.closest('[data-filter]');
    if (!button) return;

    const topic = button.dataset.filter;
    filters.querySelectorAll('button').forEach(filterButton => {
     filterButton.setAttribute('aria-pressed', String(filterButton === button));
    });

    reviewItems.forEach(review => {
     review.hidden = topic !== 'all' && review.dataset.topic !== topic;
    });

    const visibleReviewCount = reviewItems.filter(review => !review.hidden).length;
    emptyState.hidden = visibleReviewCount > 0;
    filterStatus.textContent = `${visibleReviewCount} customer ${visibleReviewCount === 1 ? 'review' : 'reviews'} shown for ${button.textContent.trim()}.`;
   });

   this.addEventListener('play', event => {
    this.querySelectorAll('video').forEach(video => {
     if (video !== event.target) video.pause();
    });
   }, true);
  }
 });
})();
